import React from 'react';
import DesignDetailsSidebar from 'contest/apps/design-details/components/design-details-sidebar';
import DesignCanvasOverlay from 'contest/apps/design-details/components/design-canvas-overlay';

export default function renderDdo(DdoComponent, designId, urls, activeUser) {
    return (
        <DdoComponent
            designId={designId}
            headerSeeMoreDesignsUrl={urls.designs}
            renderSidebar={sidebarProps => (
                <DesignDetailsSidebar urls={urls} activeUser={activeUser} {...sidebarProps} />
            )}
            renderDesignCanvasOverlay={({ design }) => <DesignCanvasOverlay design={design} />}
        />
    );
}



// WEBPACK FOOTER //
// ./src/web/js/contest/renderDdo.jsx